var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAlertsGobackHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M18.1015562,10.9229905 L8.06593936,10.9229905 L12.4503449,6.53858495 C12.800738,6.18819188 12.800738,5.61318787 12.4503449,5.2627948 C12.0999519,4.91240173 11.5339323,4.91240173 11.1835392,5.2627948 L5.2627948,11.1835392 C4.91240173,11.5339323 4.91240173,12.0999519 5.2627948,12.4503449 L11.1835392,18.3710894 C11.5339323,18.7214824 12.0999519,18.7214824 12.4503449,18.3710894 C12.800738,18.0206963 12.800738,17.4546767 12.4503449,17.1042837 L8.06593936,12.7198781 L18.1015562,12.7198781 C18.5957003,12.7198781 19,12.3155784 19,11.8214343 C19,11.3272902 18.5957003,10.9229905 18.1015562,10.9229905 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#666",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5697B7",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertsGobackHover);
export default __webpack_public_path__ + "static/media/icon_alerts_goback_hover.f9bf5e6216e17b9989f81a26c53c24d0.svg";
export { ForwardRef as ReactComponent };